import React, { createContext, useContext, ReactNode } from "react";
import { MilesPropertiesData } from "#/api/partnersShowcase/types";
import { useGetMilesProperties } from "#/requests/get-miles-properties";

interface IMilesPropertiesContext {
  properties?: MilesPropertiesData[];
  status?: "idle" | "error" | "loading" | "success";
}

const MilesPropertiesContext = createContext<IMilesPropertiesContext | null>(
  null
);

interface milesproviderProps {
  children: ReactNode;
}

export const MilesProvider: React.FC<milesproviderProps> = ({ children }) => {
  const properties = useGetMilesProperties();
  const status = properties.status;

  return (
    <MilesPropertiesContext.Provider
      value={{ properties: properties?.data, status }}
    >
      {children}
    </MilesPropertiesContext.Provider>
  );
};

export const useMilesPropeties = () => {
  return useContext(MilesPropertiesContext);
};
